export const SET_USER = "@authorization/SET_USER";
export const SET_TOKEN = "@authorization/SET_TOKEN";
export const SET_LOADING = "@authorization/SET_LOADING";